const numberFormatter = new Intl.NumberFormat('ru-RU', {
  maximumFractionDigits: 20,
})

export function limitNumberInputFraction(value: string, maxFractionDigits?: number) {
  if (maxFractionDigits == null) {
    return value
  }
  const decimalIndex = Math.max(value.lastIndexOf(','), value.lastIndexOf('.'))
  if (decimalIndex === -1) {
    return value
  }
  const limit = Math.max(0, Math.trunc(maxFractionDigits))
  if (limit === 0) {
    return value.slice(0, decimalIndex).replace(/[.,]/g, '')
  }
  let digits = 0
  for (let i = decimalIndex + 1; i < value.length; i += 1) {
    if (/\d/.test(value.charAt(i))) {
      digits += 1
      if (digits > limit) {
        return value.slice(0, i)
      }
    }
  }
  return value
}

export function parseNumberInputValue(value: string | number | null | undefined) {
  if (value == null) {
    return null
  }

  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null
  }

  const rawValue = value.trim()
  if (!rawValue) {
    return null
  }

  const compactValue = rawValue.replace(/\s/g, '')
  const decimalIndex = Math.max(compactValue.lastIndexOf(','), compactValue.lastIndexOf('.'))
  let normalizedValue = ''

  for (let i = 0; i < compactValue.length; i += 1) {
    const char = compactValue.charAt(i)

    if (/\d/.test(char)) {
      normalizedValue += char
      continue
    }

    if (i === decimalIndex) {
      normalizedValue += '.'
      continue
    }

    if (char === '-' && normalizedValue === '') {
      normalizedValue += char
    }
  }

  const parsedValue = Number(normalizedValue)
  return Number.isFinite(parsedValue) ? parsedValue : null
}

export function formatNumberInputValue(value: string | number | null | undefined) {
  if (value == null || value === '') {
    return ''
  }

  const parsedValue = parseNumberInputValue(value)
  if (parsedValue === null) {
    return String(value)
  }

  return numberFormatter.format(parsedValue).replace(/[\u00A0\u202F]/g, ' ')
}
